var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path, Defs, ClipPath } from "react-native-svg";
var SvgChainBase = function SvgChainBase(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#chain-base_svg__a)"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#EDF0F4"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M11.98 24C18.617 24 24 18.628 24 12c0-6.627-5.382-12-12.02-12C5.68 0 .512 4.836 0 10.991h15.889v2.018H0C.513 19.164 5.68 24 11.98 24Z",
    fill: "#0153FF"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "chain-base_svg__a"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
};
export default SvgChainBase;